
<template>
<div class="modal" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="mt-0 modal-title">{{ modal_title }}</h5>
                <button class="close text-white" type="button" aria-label="Close" data-dismiss="modal"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <namespace-tree 
                    v-bind="$attrs"
                    @close="hide()"
                />
            </div>
        </div>
    </div>
</div>
</template>
<script lang="js">
/**
 * Displays the namespace tree in a modal dialog, emits 'close' when it was closed.
 * The modal lifecycle is fully contained in this component, e.g. the caller does not have to trigger 'show' and 'hide' events, just 
 * put this component in a 'v-if' that is only true when the modal should be shown.
 * 
 * Set the 'escCloses' prop to False if you don't want the Escape button to close the modal.
 */

import modalLifecycle from '@/mixins/modal-lifecycle';
import namespaceTree from '../namespace-tree.vue';

export default {

    mixins: [modalLifecycle],

    inheritAttrs: false, // optional, prevents automatic binding to root element

    components: {
        namespaceTree
    },

    computed: {
        
        modal_title(){
            return  `${this.$attrs.action.startsWith('copy') ? "Copy" : "Move" } ${this.$attrs.targetFile.name}`
        }
    },

}

</script>